// extracted by mini-css-extract-plugin
export default {"notification_container":"styles-module_notification_container_D4e93Z","notificationContainer":"styles-module_notification_container_D4e93Z"};